// Los tres botones grandes de «qué tan grave es» (F2), en un solo sitio.
//
// Quien reporta no elige impacto ni urgencia por separado —eso es jerga—:
// pulsa uno de tres botones con palabras humanas. Cada uno es un par
// (impacto, urgencia) que el backend convierte en prioridad con la misma
// fórmula. El mapa vive aquí para que el botón, «Mis reportes» y el reporte
// por QR digan lo mismo. Es el gemelo de `backend/app/tickets/modelo.py`
// (GRAVEDAD): si uno cambia, cambia el otro.
export const GRAVEDADES = [
  {
    clave: 'leve',
    etiqueta: 'Puede esperar',
    detalle: 'Molesta, pero se puede seguir trabajando.',
    impacto: 1,
    urgencia: 1,
    // verde = bien / sin urgencia (consistencia de colores de estado)
    tono: 'border-green-300 bg-green-50 text-green-900',
    tonoActivo: 'border-green-500 bg-green-100 ring-2 ring-green-500',
  },
  {
    clave: 'media',
    etiqueta: 'Es para hoy',
    detalle: 'Frena el trabajo; hay que verlo hoy.',
    impacto: 2,
    urgencia: 2,
    tono: 'border-amber-300 bg-amber-50 text-amber-900',
    tonoActivo: 'border-amber-500 bg-amber-100 ring-2 ring-amber-500',
  },
  {
    clave: 'grave',
    etiqueta: 'Ya, no puedo trabajar',
    detalle: 'Todo está detenido; hay que atenderlo de inmediato.',
    impacto: 3,
    urgencia: 3,
    tono: 'border-red-300 bg-red-50 text-red-900',
    tonoActivo: 'border-red-500 bg-red-100 ring-2 ring-red-500',
  },
];

/** El par (impacto, urgencia) de una gravedad, para el botón autenticado. */
export function impactoUrgencia(clave) {
  const g = GRAVEDADES.find((x) => x.clave === clave) || GRAVEDADES[1];
  return { impacto: g.impacto, urgencia: g.urgencia };
}
